import { formatDate, Location } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, switchMap } from 'rxjs';
import { Realisation, RealisationHourtype } from 'src/app/classes/realisation';
import { CodaltComponent } from 'src/app/codalt.component';
import { PlanningService } from 'src/app/services/planning/planning.service';
import { RealisationService } from 'src/app/services/realisation.service';
import { LocalStorage } from 'src/app/storage.class';
import { Utils } from 'src/app/utils.class';

@Component({
    selector: 'app-week-schedule-planning-detail',
    templateUrl: './week-schedule-planning-detail.component.html',
    styleUrls: ['./week-schedule-planning-detail.component.scss'],
    standalone: false,
})
export class WeekSchedulePlanningDetailComponent extends CodaltComponent implements OnInit {
    readonly realisation = signal<Realisation | null>(null);
    readonly maxDate: Date;
    date: Date;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private planningService: PlanningService,
        private realisationService: RealisationService,
        private location: Location
    ) {
        super();
        this.maxDate = this.realisationService.calcMaxDate();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            combineLatest([this.activatedRoute.params, this.activatedRoute.queryParams])
                .pipe(
                    switchMap(([params, queryParams]) => {
                        this.realisation.set(null);
                        window.scroll(0, 0);
                        return this.planningService
                            .getPlanningFull(+params.planningId)
                            .pipe(map(planning => ({ planning, queryParams })));
                    })
                )
                .subscribe(({ planning, queryParams }) => {
                    const userId = LocalStorage.getUser()?.id;
                    const source = queryParams.source;
                    const rowId = +queryParams.rowId;
                    const userPlanning =
                        source === 'user_planning'
                            ? planning.user_planning?.find(item => item.id === rowId && item.user_id === userId)
                            : undefined;
                    const planningHas =
                        source === 'planning_has'
                            ? planning.planning_has?.find(item => item.id === rowId && item.driver_user_id === userId)
                            : undefined;
                    const item =
                        userPlanning ??
                        planningHas ??
                        (source === 'main' && planning.performer === userId ? planning.mainPlanning : null);
                    if (!item) {
                        return;
                    }
                    const beginDate = new Date(item.begindate);
                    this.date = Utils.setTimeNewDate(beginDate, 0, 0);
                    if (beginDate >= this.maxDate) {
                        return;
                    }
                    this.realisation.set({
                        planning_id: planning.id,
                        planning: { ...planning, planning_has_all: planning.planning_has_all ?? planning.planning_has },
                        user_id: userId,
                        user_planning: userPlanning,
                        planning_has: planningHas,
                        bookdate: this.date,
                        begindate: beginDate,
                        enddate: new Date(item.enddate),
                        hourtype: RealisationHourtype.worktime,
                    });
                })
        );
    }

    back() {
        if (window.history.length > 1) {
            this.location.back();
        } else {
            this.router.navigateByUrl(
                `weekschedule/${Utils.getWeekNumber(this.date)}/${formatDate(this.date, 'yyyy', 'nl')}`
            );
        }
    }
}
